import { render, staticRenderFns } from "./courses.vue?vue&type=template&id=3d6be9ca&scoped=true"
import script from "./courses.vue?vue&type=script&lang=js"
export * from "./courses.vue?vue&type=script&lang=js"
import style0 from "./courses.vue?vue&type=style&index=0&id=3d6be9ca&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6be9ca",
  null
  
)

export default component.exports